import React from "react";
import leftarrow from "../../img/left-arrow.png";

export default function QueryDetails() {
  return (
    <div>
      {/* <header
        style={{ backgroundColor: "#111a39" }}
        className="text-white text-lg font-medium p-4 px-8"
      >
        <div className="flex flex-col md:flex-row justify-between items-center">
          <img
            src={unologo}
            alt="Logo"
            className="h-10 mb-4 md:mb-0 cursor-pointer"
          />
          <nav>
            <ul className="flex flex-col md:flex-row gap-4 md:gap-16">
              <li>
                <a href="/" className="hover:text-gray-400">
                  Dashboard
                </a>
              </li>
              <li>
                <a href="/queries" className="hover:text-gray-400">
                  Queries
                </a>
              </li>
              <li>
                <a href="/settings" className="hover:text-gray-400">
                  Settings
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header> */}

      <div className="home px-8 min-h-screen">
        <div className="flex flex-col md:flex-row flex-start pt-4 pb-4">
          <img className="arrow-img mt-4" src={leftarrow} alt="backarrow"></img>
          <h3 className="text-white font-semibold p-2">Query Details</h3>
        </div>

        <div
          style={{ border: "2px solid rgba(54, 65, 95, 1)" }}
          className="mb-4 border-2 rounded-[16px] p-5"
        >
          <p className="text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <div className="flex flex-col md:flex-row justify-between pt-12 pb-2">
            <h3 className="text-white font-semibold p-2 pl-0">
              Submitted Date ; 2024-01-01
            </h3>
            <h3 className="text-white font-semibold p-2 pl-0">
              Status : Pending
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
